import { Observable } from 'rxjs/internal/Observable';

import { post, get } from './api-base.service';
import { IRequestId, IResponseObj } from '../models/base.model';

export default class DatabaseService {
    static backupRequest() : Observable<any> {
        return get('configuration/database/backup');
    }
}